import React from "react";

export default function PageTitles({ title }) {
  return <div className="Product-view-title">{title}</div>;
}
